// extracted by mini-css-extract-plugin
export default {"relativeWrapper":"cB_kq","container":"cB_d","focused":"cB_kr","input":"cB_ks","crossIcon":"cB_kt","searchIcon":"cB_kv"};